import { FC } from 'react';
import { Container, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import Carrousel from './app/components/global/Carrousel';
import Mission from './app/components/sections/Mission';
import About from './app/components/sections/About';
import Offer from './app/components/sections/Offer';
import Horses from './app/components/sections/Horses';
import Method from './app/components/sections/Method';
import Pricing from './app/components/sections/Pricing';
import Contact from './app/components/sections/Contact';
import Layout from './app/components/routes/Layout';
import Footer from './app/components/footer/Footer';
import Team from './app/components/sections/Team';
import { ThemeProvider as CustomThemeProvider, useThemeContext } from './app/components/global/ThemeContext';

const App: FC = () => {
  const { darkMode } = useThemeContext();

  const dynamicTheme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      background: {
        default: darkMode ? '#121212' : '#f4f4f9',
      },
      text: {
        primary: darkMode ? '#e0e0e0' : '#333333',
        secondary: darkMode ? '#b0b0b0' : '#666666',
      },
    },
    typography: {
      allVariants: {
        color: darkMode ? '#e0e0e0' : '#333333', // Ensure all text adapts to the theme
      },
    },
  });

  return (
    <CustomThemeProvider>
      <ThemeProvider theme={dynamicTheme}>
        <CssBaseline />
        <header style={{ position: 'sticky', top: 0, zIndex: 1 }}>
          <nav>
            <Layout />
          </nav>
        </header>
        <section id="top">
          <Carrousel />
        </section>
        <section>
          <Mission />
        </section>
        <Container maxWidth="md">
          <section id="about">
            <About />
          </section>
          <section id="offer">
            <Offer />
          </section>
          <section id="horses">
            <Horses />
          </section>
          <section id="method">
            <Method />
          </section>
          <section id="pricing">
            <Pricing />
          </section>
          <section id="team">
            <Team />
          </section>
          <section id="contact">
            <Contact />
          </section>
        </Container>
        <Footer />
      </ThemeProvider>
    </CustomThemeProvider>
  );
};

export default App;
